import {
  MediaCenterAllowedExtensions,
  type IMediaCenterSelection,
  type MediaCenterSubCategory,
} from "@/helpers/mediaCenter.type";
import { triggerMediaCenterOpen } from "@/helpers/mediaCenterUtil";
import type { PictureChoiceOption } from "@/types/pictureChoice";

export type PictureChoiceMediaSelection = IMediaCenterSelection &
  Partial<Pick<PictureChoiceOption, "thumbnailUrl" | "createdAt">>;

/** Applies a Media Storage selection while preserving option-only metadata. */
export const applyPictureChoiceMediaSelection = (
  option: PictureChoiceOption,
  selection: PictureChoiceMediaSelection
): PictureChoiceOption => {
  const nextOption: PictureChoiceOption = {
    ...option,
    src: selection.url,
    createdAt: selection.createdAt ?? new Date().toISOString(),
  };

  if (selection.thumbnailUrl) {
    nextOption.thumbnailUrl = selection.thumbnailUrl;
  } else {
    delete nextOption.thumbnailUrl;
  }

  return nextOption;
};

/** Opens Media Storage with the shared image-only Picture Choice settings. */
export const openPictureChoiceMediaCenter = ({
  appHandshake,
  subCategory,
  onSelect,
}: {
  appHandshake: Parameters<typeof triggerMediaCenterOpen>[0]["appHandshake"];
  subCategory: MediaCenterSubCategory;
  onSelect: (selection: PictureChoiceMediaSelection) => void;
}): void => {
  triggerMediaCenterOpen({
    appHandshake,
    settings: {
      allowedExtensions: [MediaCenterAllowedExtensions.IMAGE],
      allowMultipleFileInsertion: false,
      subCategory,
    },
    onSelect,
  });
};
